import { tooltip } from "./tooltip";

export function disabled(node, { isDisabled, message }) {
    let tooltipAction;
    
    function updateDisabled({ isDisabled, message }) {
        if (isDisabled) {
            node.setAttribute('disabled', '');
            
            if (!tooltipAction && message) {
                tooltipAction = tooltip(node, message);
            } else if (tooltipAction && message) {
                tooltipAction.update(message);
            }
        } else {
            node.removeAttribute('disabled');
            
            if (tooltipAction) {
                tooltipAction.destroy();
                tooltipAction = null;
            }
        }
    }

    updateDisabled({ isDisabled, message });

    return {
        update(params) {
            updateDisabled(params);
        },
        destroy() {
            if (tooltipAction) {
                tooltipAction.destroy();
            }
        }
    };
} 